const MAX_DIMENSION = 1600;
const INITIAL_QUALITY = 0.82;
const MIN_QUALITY = 0.4;
// Margem confortável abaixo do limite de segurança de 900_000 chars usado
// para gravar photoUrl no Firestore (ver MAX_FIRESTORE_PHOTO_CHARS em EventsContext).
const TARGET_MAX_CHARS = 700_000;

function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error ?? new Error('Falha ao ler arquivo de imagem'));
    reader.readAsDataURL(file);
  });
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Falha ao carregar imagem'));
    img.src = src;
  });
}

function scaledDimensions(width: number, height: number, maxDimension: number) {
  if (width <= maxDimension && height <= maxDimension) return { width, height };
  const scale = maxDimension / Math.max(width, height);
  return { width: Math.round(width * scale), height: Math.round(height * scale) };
}

/**
 * Redimensiona e comprime uma imagem para um data URL JPEG pequeno o
 * suficiente para caber no limite de tamanho de documento do Firestore.
 * Fotos de capa de evento vindas direto da câmera (3-11 MB em base64)
 * excediam o limite e eram silenciosamente descartadas ao salvar.
 */
export async function resizeImageToDataUrl(file: File): Promise<string> {
  const original = await readFileAsDataUrl(file);
  const img = await loadImage(original).catch(() => null);
  if (!img) return original;

  const { width, height } = scaledDimensions(img.width, img.height, MAX_DIMENSION);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) return original;

  // Fundo branco: JPEG não suporta transparência (PNGs ficariam com fundo preto).
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(img, 0, 0, width, height);

  let quality = INITIAL_QUALITY;
  let output = canvas.toDataURL('image/jpeg', quality);
  while (output.length > TARGET_MAX_CHARS && quality > MIN_QUALITY) {
    quality -= 0.1;
    output = canvas.toDataURL('image/jpeg', quality);
  }
  return output;
}
